<template>
    <spinner-until :condition="participantLoaded">
        <participant-menu>
            <div class="my-path" ref="my-path">
                <b-row>
                    <b-col>
                        <b-card no-body>
                            <b-card-header v-if="!showParticipantMenuAsAccordion">
                                <h5>
                                <span class="icon-wrapper icon-wrapper-left">
                                    <shs-icon name="arrow-top"></shs-icon>
                                </span>
                                    {{ $i18n.gt('HEADING_MY_PATH') }}
                                    <print-button content="my-path" :refs="$refs"/>
                                </h5>
                            </b-card-header>
                            <b-card-body>
                                <table class="table table-striped my-path__table">
                                    <tbody>
                                    <tr>
                                        <th>{{ $i18n.gt('LABEL_PATH_VISION') }}</th>
                                        <td>{{ path.vision }}</td>
                                        <td>
                                            <my-path-edit-modal
                                                :title="$i18n.gt('LABEL_EDIT_VISION')"
                                                :info-text="$i18n.gt('LABEL_EDIT_VISION_PROMPT')"
                                                :path="path"
                                                field="vision">
                                            </my-path-edit-modal>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ $i18n.gt('LABEL_PATH_VALUES') }}</th>
                                        <td>{{ path.values }}</td>
                                        <td>
                                            <my-path-edit-modal
                                                :title="$i18n.gt('LABEL_EDIT_VALUES')"
                                                :info-text="$i18n.gt('LABEL_EDIT_VALUES_PROMPT')"
                                                :path="path"
                                                field="values">
                                            </my-path-edit-modal>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ $i18n.gt('LABEL_PATH_CONFIDENCE') }}</th>
                                        <td>{{ path.confidence }}</td>
                                        <td>
                                            <my-path-edit-modal
                                                :title="$i18n.gt('LABEL_EDIT_CONFIDENCE')"
                                                :info-text="$i18n.gt('LABEL_EDIT_CONFIDENCE_PROMPT')"
                                                :path="path"
                                                field="confidence">
                                            </my-path-edit-modal>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </participant-menu>
    </spinner-until>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import PatientPageMixin from "@/providers/PatientPageMixin";
import PrintButton from '@/components/PrintButton'

/**
 * Page to manage a Participant's wellness path
 */
export default Vue.extend({
    name: 'MyPath',
    components: { PrintButton },
    mixins: [PatientPageMixin],
    computed: {
        participant() {
            return this.$store.state.patientParticipant
        },
        path() {
            return this.participant.wellness_plan.path
        }
    },
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
.my-path {
    .print-button {
        float: right;
        margin-top: .2em;
    }
}
.my-path__table {
    th, td {
        vertical-align: middle !important;
    }
}
</style>
